export default __webpack_public_path__ + "static/Raiz-56efb934729aabfbd5ef99b36c9ef060.svg";